var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_67577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V14C0.5 15.1046 1.39543 16 2.5 16H22.5C23.6046 16 24.5 15.1046 24.5 14V2C24.5 0.89543 23.6046 0 22.5 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13C12.2614 13 14.5 10.7614 14.5 8C14.5 5.23858 12.2614 3 9.5 3C6.73858 3 4.5 5.23858 4.5 8C4.5 10.7614 6.73858 13 9.5 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C18.2614 13 20.5 10.7614 20.5 8C20.5 5.23858 18.2614 3 15.5 3C12.7386 3 10.5 5.23858 10.5 8C10.5 10.7614 12.7386 13 15.5 13Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4C13.7144 4.91221 14.5 6.36455 14.5 8.00037C14.5 9.63618 13.7144 11.0885 12.5 12.0007C11.2856 11.0885 10.5 9.63618 10.5 8.00037C10.5 6.36455 11.2856 4.91221 12.5 4Z",
    fill: "#FF5F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_67577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.de997767ab49edbbfcdb4c583af67dfc.svg";
export { ForwardRef as ReactComponent };